import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  product_type: [],
  loading: false,
  error: null,
};

const productTypeSlice = createSlice({
  name: 'product_type',
  initialState,
  reducers: {
    setProductType: (state, action) => {
      state.product_type = action.payload;
    },
  },
});

export const { setProductType } = productTypeSlice.actions;

export default productTypeSlice.reducer;
